
import WDElement from './wd-element';

export default class WDElementCollapsible extends WDElement {

  #wrapper;
  #overflow;
  #inTransition = false;
  #connected = false;

  connectedCallback()
  {
    if (this.#connected == true) return;

    super.connectedCallback();

    this.#connected = true;

    this.#wrapper = wdc('<div class="wd-element-collapsible-wrapper is-open"/>');
    this.#overflow = wdc('<div class="wd-element-collapsible-overflow"/>');

    this.#wrapper.append(this.#overflow);
    this.before(this.#wrapper);
    this.#overflow.append(this);

    this.#wrapper.addEventListener('transitionstart',(evt) => {

      if (evt.propertyName == 'grid-template-rows')
      {
        this.#inTransition = true;
        const evtName = this.#wrapper.classList.contains('is-open') ? 'element:open' : 'element:close';
        this.trigger(evtName);
      }
    });

    this.#wrapper.addEventListener('transitionend',(evt) => {

      if (evt.propertyName == 'grid-template-rows')
      {
        this.#inTransition = false;

        const evtName = this.#wrapper.classList.contains('is-open') ? 'element:opened' : 'element:closed';
        this.#wrapper.classList.remove('is-transitioning');
        this.trigger(evtName);
      }
    });

  };

  wrapper() { return this.#wrapper; };

  /** card visibility **/
  open(animated) { 

    if (animated === false)
    {
      this.#wrapper.classList.add('is-open');
    }
    else
    {
      this.#wrapper.classList.add('is-open', 'is-transitioning');
      this.checkTransition();
    }
  };

  close(animated) { 

    if (animated === false)
    {
      this.#wrapper.classList.remove('is-open');
    }
    else
    {
      this.#wrapper.classList.add('is-transitioning');
      this.#wrapper.classList.remove('is-open');
      this.checkTransition();
    }
  };

  checkTransition()
  {
    setTimeout( () => {
      if (!this.#inTransition) this.#wrapper.classList.remove('is-transitioning');
    },100);
  };
    
  toggle(animated) 
  { 
    if ( this.isOpen() ) this.close(animated);
    else this.open(animated);
  };

  isOpen() { return this.#wrapper.classList.contains('is-open'); };

};

customElements.define('wd-element-collapsible',WDElementCollapsible);
